@if (soldOut) {
  <p class="text-center" i18n>soldout</p>
}
@if (isLoad) {
  <div class="text-center">
    <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
  </div>
}
@if (successPaymentMessage) {
  <p [innerHTML]="message.message" class="message_thanks"></p>
}
@if (erroStripe) {
  <p [innerHTML]="message.message" class="message_thanks"></p>
}

@if (!message?.error && successPaymentMessage) {
  <p i18n class="text-center">El numero de orden es el siguiente: {{ message?.id_order }}</p>
}
@if (successPaymentMessage === false) {
  @if (billing) {
    <!-- <form [formGroup]="stripeTest">
      <div class="row">
        <div class="form-group mb-3">
          <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Correo electrónico:" formControlName="email" i18n-placeholder />
        </div>
        <div class="form-group mb-3">
          <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Nombre:" formControlName="first_name" i18n-placeholder />
        </div>
        <div class="form-group mb-3">
          <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Apellido" formControlName="last_name" i18n-placeholder />
        </div>

        <div class="form-group mb-3">
          <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Calle:" formControlName="street" i18n-placeholder />
        </div>

        <div class="col-6">
          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Numero:" formControlName="number" i18n-placeholder />
          </div>
          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Codigo Postal:" formControlName="postalCode" i18n-placeholder />
          </div>
          <div class="form-group mb-3">
            <select class="form-control" name="" id="" (change)="selectCountry($event.target)" formControlName="country" i18n-placeholder>
              <option value="">Selecciona un país:</option>
              @for (item of listCountries; track $index) {
                <option [value]="item.code">{{ item.name }}</option>
              }
            </select>
          </div>

          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Teléfono:" formControlName="phone" i18n-placeholder />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Colonia:" formControlName="district" i18n-placeholder />
          </div>
          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Ciudad:" formControlName="city" i18n-placeholder />
          </div>
          <div class="form-group mb-3">
            <select class="form-control" name="" id="" formControlName="state" i18n-placeholder>
              <option value="">Selecciona el estado:</option>
              @for (item of listStates; track $index) {
                <option [value]="item.code_3_digits">{{ item.name }}</option>
              }
            </select>
          </div>

          <div class="form-group mb-3">
            <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="RFC:" formControlName="rfc" i18n-placeholder />
          </div>
        </div>
      </div>

      <button (click)="calculateShipping()" class="btn btn__default btn__block" [disabled]="">Continuar</button>
    </form> -->
  }
  @if (shippingSelect) {
    <div class="shipping_form">
      @for (item of listRate; track $index) {
        <div class="form-check">
          <label class="form-check-label">
            <input type="radio" class="form-check-input" [value]="item.service" (change)="selectRate(item.service)" />
            <fa-icon [icon]="iconFedex" size="2x"></fa-icon>
            <span class="dateShipping">{{ item.deliveryEstimate }} </span><br />
            <span class="priceShipping">{{ item.totalPrice * 1.05 | currency }}</span>
          </label>
        </div>
      }
      @if (listRate?.length >= 1) {
        <div class="form-check">
          <label class="form-check-label">
            <input type="radio" class="form-check-input" [value]="0" (change)="selectRate(0)" />
            Drop Store<span class="dateShipping">- podras recogerlo en un maximo de 72 hr o cuando se te confirme tu pedido en la tienda. </span><br />
            <!-- <span class="priceShipping">{{(item.totalPrice*1.05) |currency}}</span> -->
          </label>
        </div>
      }
    </div>
  }
  @if (paymenSelect) {
    <ng-container [class.none]="!isLoad" [class.block]="message?.stripError">
      <p>
        Tus pagos son procesados con :
        <fa-icon [icon]="iconStripe" size="2x"></fa-icon>
      </p>

      <div [formGroup]="stripeCardForm" ngxStripeCardGroup [elementsOptions]="elementsOptions" [stripe]="stripe">
        <div class="row container_card">
          <div class="col-12">
            <ngx-stripe-card-number [options]="cardOptions" containerClass="input-card mb-3 "></ngx-stripe-card-number>
          </div>
          <div class="col-6">
            <ngx-stripe-card-expiry [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-expiry>
          </div>
          <div class="col-6">
            <ngx-stripe-card-cvc [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-cvc>
          </div>
        </div>

        <button type="submit" (click)="createToken()" class="btn btn__default btn__block mt-3 mb-3" [class.d-block]="!loadingToken" [class.d-none]="loadingToken">Comprar</button>
        <div class="text-center" [class.d-block]="loadingToken" [class.d-none]="!loadingToken">
          <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
        </div>
      </div>

      <p i18n>Al dar click en Pagar damos por hecho de que aceptas nuestros Términos y Condiciones y Política de Devolución y Reembolso</p>
    </ng-container>
  }
}
